import { AxiosRequestConfig } from "axios";

export const LOG_LEVEL = {
	trace: 10,
	debug: 20,
	info: 30,
	warn: 40,
	error: 50,
	fatal: 60,
};

export type LogMeta = {
	done_in?: number;

	url?: string;
	method?: string;
	requestConfig?: AxiosRequestConfig;
	purchaseId?: number;

	platform?: "webapp" | "server"; // set automatically

	error?: {
		statusCode?: string | number;
		message?: string;
		stack: any;
	};

	extra?: object;
};

export interface LogEntry {
	message: string;
	level: keyof typeof LOG_LEVEL;
	level_id: number;
	timestamp: string;

	tx: {
		service: string;
		env?: string;
	} & LogMeta;
}

export interface LogEntryAPI extends LogEntry {
	component: string;
}
